import React, { useState } from "react";
import BasicInfo from "./BasicInfo";

export default function MyAccount() {

  return (
    <div className="container bg-white">
      <div className="blueBanner">
        <p className="text-white p-3 mx-3 my-0 fw-bold fontSize20 ">
          Account Details
        </p>
      </div>
 
      <div><BasicInfo /></div>

    </div>
  );
}
